import React from 'react'
import { connect } from 'react-redux'
import Select from 'react-select'
import { ContentHeader, StaticBox, LinkedInput, LinkedInputGroup } from 'components/basic'
import FlowView from 'components/core/FlowView'
import Datetime from 'react-datetime'
import { notify, FormHelper } from 'helpers'
import http from 'API/http'

const priorities = [
  {
    name: 'CRITICAL',
    value: 'CRITICAL'
  },
  {
    name: 'MEDIUM',
    value: 'MEDIUM'
  }
]
class TicketCreate extends FlowView {
  constructor (props) {
    super(props, 'Overview')
    this.state = {
      updated: Date.now(),
      tabIndex: 0,
      searchQuery: '',
      customerQuery: '',
      accesses: [],
      customers: [],
      access: null,
      activate: [],
      timer: null,
      searching: false,
      new: {
        title: '',
        description: '',
        priority: 'MEDIUM',
        spReference: ''
      }
    }
  }
  async componentDidMount () {
    if (this.props.match.params.accessId) {
      await this.selectAccess({
        accessId: this.props.match.params.accessId
      })
      if (this.props.match.params.service && this.props.match.params.service !== 'null') {
        this.selectService({
          service: window.atob(this.props.match.params.service)
        })
        this.setState({tabIndex: 2})
      }
    }
  }
  isDateValid (current) {
    var yesterday = Datetime.moment().subtract(1, 'day')
    return current.isAfter(yesterday)
  }
  async selectAccess (access) {
    var err, res
    [err, res] = await http.get('2.3/accesses/' + access.accessId)
    if (err) return notify.warn('Could not load access')
    this.setState({access: res.data, tabIndex: 1, activate: []})
  }
  selectService (service) {
    if (this.state.activate.map(s => s.service).indexOf(service.service) !== -1) return
    this.setState({activate: [...this.state.activate, {...service, date: Datetime.moment().format('YYYY-MM-DD HH:mm')}]})
  }
  async createTicket () {
    var valid = await FormHelper.validate(this.form)
    if (!valid) return
    var err, res
    [err, res] = await http.post('2.3/tickets', {
      ...this.state.new,
      accessId: this.state.access.accessId,
      services: this.state.activate
    })
    if (err) return notify.alert('', err.cause, 'error')
    window.location.hash = '/ticket/' + res.data.ticketRef
  }
  render () {
    return (
      <div className='content-wrapper'>
        <ContentHeader title='Trouble Tickets' subtitle='Create ticket wizard' />
        <hr />
        <div className='row'>
          <StaticBox cols={12} icon='play' title={(this.state.access ? `${this.state.access.streetName} ${this.state.access.streetNumber} ${this.state.access.mduApartmentNumber} ${this.state.access.mduDistinguisher}` : 'Select Access')}>
            <LinkedInputGroup ref={form => (this.form = form)}>
              <div className='row'>
                <div className='col-md-3'>
                  <label>Title</label>
                  <LinkedInput context={this} path='new.title' errorMessage='This field is required' validate={/\w{1,}/i} />
                </div>
                <div className='col-md-3'>
                  <label>Contact Info</label>
                  <LinkedInput context={this} path='new.contactInfo' />
                </div>
                <div className='col-md-3'>
                  <label>Priority</label>
                  <Select
                    value={this.state.new.priority}
                    onChange={e => this.setState({new: {...this.state.new, priority: e.value}})}
                    options={priorities}
                    valueKey='value'
                    labelKey='name'
                    clearable={false}
                  />
                </div>
                <div className='col-md-3'>
                  <label>Your Internal Reference</label>
                  <LinkedInput context={this} path='new.spReference' />
                </div>
              </div>
              <div className='row'>
                <div className='col-md-12'>
                  <label>Description</label>
                  <textarea style={{width: '100%'}} rows='10' className='form-control' onChange={e => this.setState({ new: {...this.state.new, description: e.target.value} })} />
                </div>
              </div>
              <div className='col-md-12'>
                <hr />
                <div className='row'>
                  <div className='col-md-push-6 col-sm-6'>
                    <a onClick={e => this.createTicket()} className='btn btn-primary pull-right margin-left-10'>Create ticket</a>
                  </div>
                </div>
              </div>
            </LinkedInputGroup>
          </StaticBox>
        </div>
      </div>
    )
  }
}
//eslint-disable-next-line
TicketCreate = connect(state => state.siteReducer)(TicketCreate)
export default TicketCreate



// WEBPACK FOOTER //
// ./src/projects/flow-gui-access/views/2.3/ticket/create.js